import storage from 'proxy-storage'
import getById from 'utils/DOM/getById'
import buildControllerHeightFt from 'core/controllers/buildControllerHeightFt'
import buildControllerHeightIn from 'core/controllers/buildControllerHeightIn'
import buildControllerWeight from 'core/controllers/buildControllerWeight'
import getValidValues from '../controller/getValidValues'
import toggleClass from 'utils/DOM/toggleClass'
import appendMember from './appendMember'
import buildMemberController from './buildMemberController'
import { findChildren } from '@hc-frontend/business'

const familyWrap = getById('family-wrap')
const controllers = {}

function showQuestions(controllers) {
  const controllersAreValid =
    controllers &&
    Object.keys(controllers).reduce(
      (accum, current) => accum && controllers[current].getStatus().valid,
      true
    )

  toggleClass('#questions-container', 'd-none', !controllersAreValid)
}

function showWeightHeight(members, eligibilityForm, childOnly, onUpdate) {
  if (childOnly) {
    members = findChildren(members)
  } else {
    members.sort((a, b) =>
      a.id === 'primary' || (a.id === 'spouse' && b.id.indexOf('child') >= 0) ? -1 : 1
    )
  }

  members.forEach(_member => {
    const under15 = _member.age < 15
    const member = Object.assign({}, _member)
    let suffix = ''
    suffix = appendMember(member, familyWrap, under15)

    if (under15) {
      return
    }

    const heightFtKey = `heightft${suffix}`
    const heightInKey = `heightin${suffix}`
    const weightKey = `weight${suffix}`

    controllers[heightFtKey] = buildControllerHeightFt({
      input: eligibilityForm[heightFtKey]
    })
    controllers[heightInKey] = buildControllerHeightIn({
      input: eligibilityForm[heightInKey]
    })
    controllers[weightKey] = buildControllerWeight({
      input: eligibilityForm[weightKey]
    })

    controllers[member.id] = buildMemberController(member, suffix, controllers)

    if (member.height) {
      controllers[heightFtKey].setValue(member.height.feet || '')
      controllers[heightInKey].setValue(member.height.inches || '')
    }
    controllers[weightKey].setValue(member.weight || '')
    controllers[member.id].validate()
  })

  showQuestions(controllers)

  familyWrap.addEventListener('change', e => {
    if (e.target && e.target.matches('.form-control')) {
      const id = e.target.dataset.id
      controllers[id].validate()
      controllers[e.target.id].validate()
      showQuestions(controllers)
    }
  })

  familyWrap.addEventListener('click', e => {
    e.preventDefault()

    if (e.target && e.target.matches('.js-remove-member')) {
      const id = e.target.dataset.id
      const hcStorage = storage.getItem('hc')
      const isSpouse = id === 'spouse'
      const isChild = id.indexOf('child') >= 0
      const suffix = isSpouse ? '_s' : isChild ? `${id.replace('child', '')}` : ''
      const keys = [`heightft${suffix}`, `heightin${suffix}`, `weight${suffix}`]
      keys.forEach(key => {
        controllers[key].destroy()
        delete controllers[key]
      })
      const { formValues } = getValidValues(controllers)
      hcStorage.members = hcStorage.members.filter(person => person.id !== id)
      onUpdate({ hcStorage, formValues })
    }
  })

  return controllers
}

export default showWeightHeight
